import { create } from "zustand";

type PopUpVariant = "ScrollPhotos" | "SeeViewers" | "PhotoDetail" | "VideoDetail" | "SeePhotos";
export interface GatheringPreviewPublicStore {
	refCode: string;
	gatheringId: string;
	gatheringName: string | undefined;
	handleJoinGathering: () => void;
	joinLoading: boolean;
	popUpVariant: null | PopUpVariant;
	setPopUpVariant: (variant: null | PopUpVariant) => void;
}

export const createGatheringPreviewPublicStore = (
	initial: Pick<
		GatheringPreviewPublicStore,
		"refCode" | "gatheringId" | "handleJoinGathering" | "joinLoading" | "gatheringName"
	>,
) => {
	return create<GatheringPreviewPublicStore>((set) => ({
		popUpVariant: null,
		setPopUpVariant: (variant) => set({ popUpVariant: variant }),
		...initial,
	}));
};
